import {h, Fragment} from "preact"
import { useFacets, useActions } from "@nosto/preact"
import Facet from "./Facet"
import RangeFacet from "./RangeFacet"
import Icon from "./elements/Icon"

import { useEffect, useState, useRef } from 'preact/hooks'

import SelectedFilters from "./SelectedFilters"


// new imports for sorting
import { useAppState, useSelectedFiltersCount, useSort } from "@nosto/preact"
import { sortOptions, SIDEBAR_ID, MOBILE } from "../config"
import Select from "./elements/Select"

function ToggleSidebarButton({ className }) {
    return (
        <label
            className={`debug-border-red ns-act-btn ns-close-sidebar ns-absolute ns-d-block ns-d-md-none ns-text-align-right ns-align-items-center ns-clickable ns-font-3 ${className}`}
            for={SIDEBAR_ID}
        >
            <Icon name="close" />
        </label>
    )
}

export default function SideBar({ toggleId }) {
    const { loading, facets } = useFacets()
    const { updateSearch } = useActions()
    const { activeSort, setSort } = useSort(sortOptions)
    const options = sortOptions.map(o => ({ value: o.id, label: o.value.name }))

    const [ sortActive, setSortActive ] = useState(false);
    const [ sortIsActive, setSortIsActive ] = useState(false)
    const [ scrollYPosition, setScrollYPosition ] = useState(0);

    const sidebarRef = useRef(null);

    const mobile = window.innerWidth <= 768;
    const valueToLabelMap = {
        'score': "Featured",
        '-price': "Price, high to low",
        'price': "Price, low to high",
        'newest': "Newest",
        '-newest': "Oldest",
        'revenue': "Best Sellers",
    }

    const handleSortChange = (event) => {
        setSort(event.target.value);
        setSortIsActive(false);

    }

    useEffect(() => {
        if (mobile) return;
        const handleScroll = () => {
            setScrollYPosition(prevScrollYPosition => {
                const currentScrollYPosition = window.scrollY;
                if (currentScrollYPosition >= 280) {
                    if (currentScrollYPosition > prevScrollYPosition) {
                        sidebarRef.current?.classList.add("nav-hidden");
                    } else if (currentScrollYPosition < prevScrollYPosition) {
                        sidebarRef.current?.classList.remove("nav-hidden");
                    }
                }
                return currentScrollYPosition;
            });
        };
    
        window.addEventListener('scroll', handleScroll);
    
        return () => window.removeEventListener('scroll', handleScroll);
    }, []);

    return facets?.length > 0 ? (
        <>
        <input type="checkbox" id={SIDEBAR_ID} class="ns-facet-sidebar-toggle ns-d-none" />
            <label
                class="ns-sidebar-backdrop ns-fixed ns-w-100 ns-h-100 ns-background-black ns-d-none"
                for={SIDEBAR_ID}
            />
            <div
                class="debug-border-red ns-sidebar-wrapper ns-d-none ns-d-md-block ns-col-3 ns-col-l-2"
                style={loading ? "opacity: 0.3;" : ""}
                ref={sidebarRef}
            >
                <div class="ns-sidebar-content ns-relative ns-background-white ns-h-100 ns-mr-0 ns-mr-md-auto">
                    <div class="sort-container">
                        <div class="heading-font">Sort By</div>
                        <div 
                            class="active-value"
                            onClick={(e) => {
                                setSortIsActive(prevSortIsActive => !prevSortIsActive)
                            }}
                        >
                            <div className="select-sortby-value"> {valueToLabelMap[activeSort]} </div>
                            <Icon name="arrow" className={`ns-absolute sorting-arrow ${sortIsActive ? 'rotated' : ''}`} />
                        </div>
                        {sortIsActive &&
                            <ul class="unstylish-list collection-sortby-detail pos-absolute w-100 high-z" id="sort__list">
                                {options.map((option, idx) => (
                                    <li 
                                        key={option.value}
                                        class="collection-sortby-item selected select-sortby-option"
                                    >
                                        <div class="custom-checkbox radio-box">
                                            <input 
                                                class="checkmark-input" 
                                                type="radio" 
                                                name="sort_by" 
                                                id={`sortByOption-${option.value.toLowerCase().replaceAll(' ', '-')}`} 
                                                value={option.value}
                                                checked={activeSort === option.value}
                                                onChange={handleSortChange}
                                            />
                                            <label 
                                                class={`${activeSort === option.value ? "active" : ""}`}
                                                for={`sortByOption-${option.value.toLowerCase().replaceAll(' ', '-')}`}
                                            >
                                                {option.label}
                                            </label>
                                        </div>
                                    </li>
                                ))
                                }
                            </ul>
                        }
                    </div>
                    <div class="ns-sidebar-header ns-d-flex ns-align-items-baseline filter-header-padding">
                        <span class="filter-icon">
                            <svg width="22" height="20" viewBox="0 0 12 11" fill="none">
                                <path d="M0 9.77778L8.21516e-08 8.55556H2.53875V7.33333H4.23125V8.55556H11.8475V9.77778H4.23125V11H2.53875V9.77778H0ZM2.46314e-07 6.11111L3.28396e-07 4.88889H7.61625V3.66667H9.30876V4.88889H11.8475V6.11111H9.30876V7.33333H7.61625V6.11111H2.46314e-07ZM4.92629e-07 2.44444L5.7471e-07 1.22223H2.53875V0L4.23125 4.80826e-08V1.22223H11.8475V2.44444H4.23125V3.66667H2.53875V2.44444H4.92629e-07Z" fill="currentColor"></path>
                            </svg>
                        </span>
                        <span class="ns-font-medium ns-font-5 ns-color-black heading-font">Filter By</span>
                        <ToggleSidebarButton />
                    </div>
                    <div class='mobile-selected-filters'>
                        <SelectedFilters />
                    </div>
                    <div class="ns-sidebar-menu filter-drawer-form">
                        <ul class="ns-list-unstyled ns-p-0 ns-m-0">
                            {facets?.map(facet => {
                                switch (facet.type) {
                                    case "terms":
                                        return <Facet facet={facet} key={facet.id} />
                                    case "stats":
                                        return <RangeFacet facet={facet} />
                                    default:
                                        return null
                                }
                            })}
                        </ul>
                    </div>
                </div>
                <div 
                    class="apply-button"
                    onClick={() => {
                        document.querySelector('.ns-serp .ns-close-sidebar').click()
                    }}
                >
                    Show Results
                </div>
            </div>
        </>
    ) : ( "" )
}
